export const CONTRACTOR_JOB_STATUS_COLOR = {
  ACTIVE: 'var(--ruthless-empress)',
  ACCEPTED: 'var(--ruthless-empress)',
  HOLDING: 'var(--simply-peachy)',
  COMPLETED: 'var(--boogie-blast)',
  DECLINED: 'var(--flushed)',
  DEAL: 'var(--ruthless-empress)',
  HOLD: 'var(--simply-peachy)',
  HOLD_MEMO: 'var(--simply-peachy)',
  DEAL_MEMO: 'var(--ruthless-empress)'
};
